export default "__VITE_ASSET__BQv_bQYB__"